import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Typography,
  Stack,
  Grid2,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from '@mui/material';
import { toast } from 'sonner';
import { Iconify } from '../Minimal/src/components/iconify';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import '../common/commonStyles.css';

const StartStockTake = () => {
  const [pageOptions] = useState([
    { value: 'categories', label: 'Categories' },
    { value: 'brands', label: 'Brands' },
    { value: 'all', label: 'All' }
  ]);
  const [pageFilterValue, setPageFilterValue] = useState('categories');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryValue, setCategoryValue] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandValue, setBrandValue] = useState([]);
  const accessToken = localStorage.getItem('accessToken');
  const [isStockTakeOpen, setIsStockTakeOpen] = useState(false);
  const token = localStorage.getItem("token");

  const navigateToGRNList = useNavigate();

  const handlePageChange = (event) => {
    const value = event.target.value;
    setPageFilterValue(value);
    setCategoryValue([]);
    setBrandValue([]);
  };

  const fetchCategoriesOptions = async () => {
    const apiCategoriesUrl = `${API_URL}/stock_take/getCategories`;
    try {
      const response = await fetch(apiCategoriesUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();

      const formattedOptions = data.data.category.map(item => ({
        value: item.id,
        label: item.name,
      }));

      setCategoryOptions(formattedOptions);
    } catch (error) {
      toast.error('Failed to load categories');
    }
  };

  const fetchBrandOptions = async () => {
    const apiBrandsUrl = `${API_URL}/stock_take/getBrands`;
    try {
      const response = await fetch(apiBrandsUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      const formattedOptions = data.data.brands.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setBrandOptions(formattedOptions);
    } catch (error) {
      toast.error('Failed to load brands');
    }
  };

  const fetchStockTakeStart = async () => {
    const apiBrandsUrl = `${API_URL}/stock_take/get_StockTakeStartOrNot`;
    try {
      const response = await fetch(apiBrandsUrl, {
        method: 'get',
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setIsStockTakeOpen(data.success);
    } catch (error) {
      toast.error('Failed to check stock take status');
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchCategoriesOptions();
    fetchBrandOptions();
    fetchStockTakeStart();

    document.title = 'Start Stock Take';
    return () => {
      document.title = 'Ebusso';
    };
  }, [accessToken]);

  const handelStartStack = async () => {
    const formData = new FormData();
    if (pageFilterValue === 'categories') {
      if (categoryValue.length > 0) {
        categoryValue.forEach(value => {
          formData.append('category[]', value.value);
        });
      } else {
        toast.error('Please select categories to start stock take');
        return;
      }
    } else if (pageFilterValue === 'brands') {
      if (brandValue.length > 0) {
        brandValue.forEach(value => {
          formData.append('brand[]', value.value);
        });
      } else {
        toast.error('Please select brand to start stock take');
        return;
      }
    } else if (pageFilterValue === 'all') {
      formData.append('all', 'all');
    }
    const apiAddOrdersUrl = `${API_URL}/products/start_stock_take`;
    try {
      const response = await fetch(apiAddOrdersUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success === true) {
        toast.success('Start stock take successfully');
        setTimeout(() => {
          setCategoryValue([]);
          setBrandValue([]);
          navigateToGRNList("/stock_take/history");
        }, 1000);
      } else {
        toast.error('No Products Data found.');
      }
    } catch (error) {
      toast.error('Error starting stock take. Please try again.');
    }
  };

  return (
    <>
        <Box className="page-container">
          <Paper className="paper-style">
            <Box sx={{ px: 2, py: 1.2 }}>
              <Grid2 container spacing={2} sx={{ mb: 2 }}>
                <Grid2 size={{ xs: 12, md: 4 }}>
                  <Typography className="page-title">
                    Start Stock Take
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ fontSize: "0.875rem" }}>Select Options</InputLabel>
                    <Select
                      value={pageFilterValue}
                      label="Select Options"
                      onChange={handlePageChange}
                      className="input-border"
                      sx={{
                        fontSize: "0.875rem",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                        "& .MuiSelect-select": {
                          fontSize: "0.875rem",
                        },
                      }}
                    >
                      {pageOptions.map(option => (
                        <MenuItem key={option.value} value={option.value} sx={{ fontSize: "0.875rem" }}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid2>

                {pageFilterValue === 'categories' && (
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Autocomplete
                      multiple
                      options={categoryOptions}
                      value={categoryValue}
                      onChange={(event, newValue) => {
                        setCategoryValue(newValue);
                      }}
                      getOptionLabel={(option) => option.label || ''}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      renderInput={(params) => (
                        <TextField
                      
                          {...params}
                          placeholder="Select Categories"
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#f5f7fa",
                              fontSize: "0.875rem",
                              "&:hover": {
                                backgroundColor: "#fff"
                              },
                              "&.Mui-focused": {
                                backgroundColor: "#fff"
                              }
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "0.875rem",
                            },
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                      }}
                    />
                  </Grid2>
                )}

                {pageFilterValue === 'brands' && (
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Autocomplete
                      multiple
                      options={brandOptions}
                      value={brandValue}
                      onChange={(event, newValue) => {
                        setBrandValue(newValue);
                      }}
                      getOptionLabel={(option) => option.label || ''}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      renderInput={(params) => (
                        <TextField
                        
                          {...params}
                          placeholder="Select Brands"
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#f5f7fa",
                              fontSize: "0.875rem",
                              "&:hover": {
                                backgroundColor: "#fff"
                              },
                              "&.Mui-focused": {
                                backgroundColor: "#fff"
                              }
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "0.875rem",
                            },
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#f5f7fa",
                          fontSize: "0.875rem",
                          "&:hover": {
                            backgroundColor: "#fff"
                          },
                          "&.Mui-focused": {
                            backgroundColor: "#fff"
                          }
                        },
                      }}
                    />
                  </Grid2>
                )}
              </Grid2>

              <Divider sx={{ my: 2 }} />

              {!isStockTakeOpen && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                  <Button
                    variant="contained"
               
                    onClick={handelStartStack}
                    startIcon={<Iconify icon="eva:play-fill" width={16} />}
                    className="button-variant-contained"
                    sx={{

                      mb: 4,
                    }}
                  >
                    Start Stock Take
                  </Button>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>
    </>
  );
};

export default StartStockTake;
